/**
 * Information needed to make a third party data request
 * @module
 */

var _ = require('optimizely-client-fn');
var actionTypes = require('../constants/action_types');

/**
 * @typedef {Object} IntegrationSettings
 * @property {string} id Integration ID
 */

/**
 * Holds the project-level integration settings
 */
module.exports = {
  initialize: function() {
    this.__state = {} as any;

    this.on(actionTypes.DATA_LOADED, this.__loadData);
    this.on(actionTypes.SET_INTEGRATION_SETTINGS, this.__updateSetting);
  },

  /**
   * Loads layer data into the store state
   * @param {Object} payload
   * @param {ClientData} data
   * @private
   */
  __loadData: function(payload:any) {
    if (_.isEmpty(payload.data.integrationSettings)) {
      return;
    }
    _.each(payload.data.integrationSettings, _.bind(function(setting) {
      this.__state[setting.id] = setting;
    }, this));
    this.emitChange();
  },

  /**
   * @param {IntegrationSettings} payload
   * @private
   */
  __updateSetting: function(payload:IntegrationSettings) {
    var existing = this.__state[payload.id];
    if (existing) {
      _.extend(existing, payload);
    } else {
      this.__state[payload.id] = payload;
    }
  },

  /**
   * @return {IntegrationSettings[]}
   */
  getAll: function(): IntegrationSettings[] {
    return _.cloneDeep(_.values(this.__state));
  },

  /**
   * @param {string} id
   *
   * @return {IntegrationSettings|null}
   */
  get: function(id:string): IntegrationSettings|null {
    return _.cloneDeep(this.__state[id]);
  },

  /**
   * Get a direct reference to the store (for when referential equality is important)
   *
   * IMPORTANT! Do *not* modify the returned value.
   * @param {string} id
   *
   * @return {IntegrationSettings|null}
   */
  getReference: function(id:string): IntegrationSettings|null {
    return this.__state[id];
  },
};

